<div class="okta-container">
  <div class="row okta-wrapper">
    <div class="okta-form-row" *ngIf="websiteName =='Parmed'|| (websiteName== 'Major'&& !isDesktopDevice())">
      <div class="row logo-holder">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 logo-block">
          <img class="app-logo" src="./assets/images/{{websiteName}}/LogoNew.png" alt="" />
        </div>
      </div>
      <div class="row box-container">
        <form novalidate #changeForm="ngForm" class="form-info" (ngSubmit)="onChangePasswordSubmit(changeForm)">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <p class="exp-message">Change Your Password</p>
            <div *ngIf="pwdExpired" class="pwd-exp-message">
              <div id="business-managed-alert" class="businessManagedAlert-margin-bottom">Your password has expired. Please complete the form below to create a new password.
              </div>
            </div>
            <div class="has-error okta-error" *ngIf="change.errorMessage">
              <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
              <p class="show-message">
                <span title="{{change.errorMessage}}">{{change.errorMessage}}</span>
              </p>
            </div>
            <ul class="form-grid">
              <li class="change-control">
                <mat-form-field>
                  <input matInput name="oldpassword" type="password" required #oldpassword="ngModel" placeholder="Enter Current Password" [(ngModel)]="change.oldPassword"
                    parAutoFocus />
                  <mat-error *ngIf="oldpassword.errors?.required">Current password is required.</mat-error>
                </mat-form-field>
              </li>
              <li class="change-control">
                <mat-form-field>
                  <input id="new-password" matInput name="newpassword" type="password" required #newpassword="ngModel" placeholder="Enter New Password" [(ngModel)]="change.newPassword"
                    parValidateEqual="confirmPassword" reverse="true" [pattern]="validation.passwordRegex">
                  <mat-error *ngIf="newpassword.errors?.required">New password is required.</mat-error>
                </mat-form-field>
              </li>
              <li class="change-control">
                <div>
                  <mat-form-field>
                    <input id="confirm-password" matInput name="confirmPassword" type="password" required #confirmPassword="ngModel" placeholder="Confirm New Password"
                      parValidateEqual="newpassword" [(ngModel)]="change.confirmPassword" [pattern]="validation.passwordRegex">
                    <mat-error *ngIf="confirmPassword.errors?.required">Confirm password is required.</mat-error>
                    <mat-error *ngIf="confirmPassword.errors?.validateEqual">New password and confirm password do not match.</mat-error>
                  </mat-form-field>
                </div>
              </li>
              <li class="password-hint">
                <p *ngIf="!newpassword.errors?.pattern && !confirmPassword.errors?.pattern">{{messages.passwordHint}}</p>
                <div *ngIf="newpassword.errors?.pattern || confirmPassword.errors?.pattern" class="has-error okta-error">
                  <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
                  <p class="show-message">
                    <span>{{messages.passwordHint}}</span>
                  </p>
                </div>
              </li>
              <li>
                <div class="okta-action-buttons">
                  <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Cancel</button>
                  <button id="btn-submit" type="submit" mat-raised-button color="accent" [disabled]="changeForm.invalid">Change Password</button>
                </div>
              </li>
            </ul>
          </div>
        </form>
      </div>
    </div>
    
  <div class="form-container-change" *ngIf="websiteName =='Major' && isDesktopDevice()">
    <form  novalidate #changeForm="ngForm" class="form-info" (ngSubmit)="onChangePasswordSubmit(changeForm)">
      <div *ngIf="pwdExpired" class="pwd-exp-message">
        <div id="business-managed-alert" class="businessManagedAlert-margin-bottom">Your password has expired. Please complete the form below to create a new password.
          </div>
      </div>
      <div class="has-error okta-error" *ngIf="change.errorMessage">
        <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
          <p class="show-message">
             <span title="{{change.errorMessage}}">{{change.errorMessage}}</span>
          </p>
      </div>
      <div class="form-group">
        <label for="oldpassword">Enter Current Password <span>*</span></label>
        <input matInput name="oldpassword" type="password" required #oldpassword="ngModel" placeholder="Enter Current Password" [(ngModel)]="change.oldPassword"
          parAutoFocus />
        <mat-error *ngIf="oldpassword.invalid && oldpassword.touched">Current password is required.</mat-error>
      </div>
 
      <div class="form-group">
        <label for="newPassword">Enter New Password <span>*</span></label>
        <input id="new-password" matInput name="newpassword" type="password" required #newpassword="ngModel" placeholder="Enter New Password" [(ngModel)]="change.newPassword"
            parValidateEqual="confirmPassword" reverse="true" [pattern]="validation.passwordRegex">
          <!-- <mat-error *ngIf="newpassword.errors?.required &&changeForm.submitted">New password is required.</mat-error> -->
          <mat-error *ngIf="newpassword.invalid && newpassword.touched">New password is required.</mat-error>
      </div>
 
      <div class="form-group">
        <label for="confirmPassword">Confirm New Password <span>*</span></label>
       <input id="confirm-password" matInput name="confirmPassword" type="password" required #confirmPassword="ngModel" placeholder="Confirm New Password"
         parValidateEqual="newpassword" [(ngModel)]="change.confirmPassword" [pattern]="validation.passwordRegex">
        <mat-error *ngIf="confirmPassword.invalid && confirmPassword.touched ">Confirm password is required.</mat-error>
        <mat-error *ngIf="confirmPassword.errors?.validateEqual">New password and confirm password do not match.</mat-error>
      </div>
 
      <div class="hint">
      <p *ngIf="!newpassword.errors?.pattern && !confirmPassword.errors?.pattern">{{messages.passwordHint}}</p>
          <div *ngIf="newpassword.errors?.pattern || confirmPassword.errors?.pattern" class="has-error okta-error">
            <span class="glyphicon glyphicon-exclamation-sign error-exclamation"></span>
              <p class="show-message">
                <span>{{messages.passwordHint}}</span>
              </p>
            </div>
      </div>
 
      <div class="btn-group">
        <button id="btn-cancel" type="button" mat-raised-button color="accent" (click)="onCancelClick()">Cancel</button>
        <button id="btn-submit" type="submit" mat-raised-button color="accent" [disabled]="changeForm.invalid">Change Password</button>
      </div>
    </form>
  </div>
  </div>
</div>